export default __webpack_public_path__ + "static/media/check_green.fdf99e85.svg";